<ion-grid class="table height-toolbar-2">

    <ion-row class="table-header">
        <ion-col class="flex-align-center" i18n=":@@configurations_permissions.number">Nº Cartão</ion-col>
        <ion-col class="flex-align-center" i18n=":@@configurations_permissions.datestart">Início</ion-col>
        <ion-col class="flex-align-center" i18n=":@@configurations_permissions.dateend">Fim</ion-col>

    </ion-row><ion-row *ngFor="let item of Data" style="display: block;">
        <ion-item class="ion-no-margin">

            <ion-grid class="ion-no-margin ion-no-padding">

                <ion-row class="table-body with-button-opacity">

                    <ion-col class="flex-align-center">{{ item?.Number }}</ion-col>
                    <ion-col class="flex-align-center">
                        <date-tooltip [date]="item?.StartDate"></date-tooltip>
                    </ion-col>
                    <ion-col class="flex-align-center">
                        <date-tooltip [date]="item?.EndDate"></date-tooltip>
                    </ion-col>

                </ion-row>

            </ion-grid>

        </ion-item>

    </ion-row>


    <ion-row *ngIf="!Data || Data?.length == 0">
        <ion-col>
            <no-items></no-items>
        </ion-col>
    </ion-row>

    <!-- <pagination-control [totalItems]="Data?.length" (pageChange)="OnChangePage($event)">
	</pagination-control> -->

</ion-grid>